<template>
	<div>

		<Form ref="form" :model="modalformValidata" :label-width="150" label-position="right">
			<Row type="flex" justify="center" align="middle">
				<Col :span="6">
				<FormItem label="所属分组：" prop="locationGroup" label-for="locationGroup">
					<Input v-model="modalformValidata.locationGroup" placeholder="请输入"
						element-id="locationGroup" />
				</FormItem>
				</Col>
				<Col :span="6">
				<FormItem label="路径id：" prop="locationId" label-for="locationId">
					<Input v-model="modalformValidata.locationId" placeholder="请输入" element-id="locationId" />
				</FormItem>
				</Col>
				<Col :span="6">
				<FormItem label="访问路径：" prop="locationUrl" label-for="locationUrl">
					<Input v-model="modalformValidata.locationUrl" placeholder="请输入" element-id="locationUrl" />
				</FormItem>
				</Col>
				<Col :span="6" class="ivu-text-right">
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
					<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
				</FormItem>
				</Col>

			</Row>
		</Form>
		<Button type="success" ghost size="large" @click="locationAddMain()">新增路径</Button>
		<Table stripe :columns="columns1" :data="data1">
			<template slot="action" slot-scope="{ row, index }">
				<Button type="info" ghost size="small" style="margin-right: 5px"
					@click="locationEditMain(row)">编辑</Button>
				<Button type="error" ghost size="small" @click="locationDelMain(row)">删除</Button>
			</template>
		</Table>
		<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage" show-total
			show-elevator next-text="下一页" />

		<div>
			<Modal v-model="modal1" title="路径新增" width="30%" @on-ok="locationAddfunc()">
				<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
					<FormItem label="所属分组：" prop="locationGroup">
						<Input v-model="modalformValidata.locationGroup" />
					</FormItem>
					<FormItem label="访问路径：" prop="locationUrl">
						<Input v-model="modalformValidata.locationUrl" />
					</FormItem>
					<FormItem label="连接版本：" prop="apiVersion">
						<Input v-model="modalformValidata.apiVersion" />
					</FormItem>
					<FormItem label="请求类型：" prop="httpMethod">
						<RadioGroup v-model="modalformValidata.httpMethod">
							<Radio label="GET">
								<span>GET</span>
							</Radio>
							<Radio label="POST">
								<span>POST</span>
							</Radio>
							<Radio label="PUT">
								<span>PUT</span>
							</Radio>
							<Radio label="PATCH">
								<span>PATCH</span>
							</Radio>
							<Radio label="DELETE">
								<span>DELETE</span>
							</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="访问角色code：" prop="roleCodes">
						<CheckboxGroup v-model="modalformValidata.roleCodes" @on-change="change">
							<Checkbox :label="item.dictValue+':'+item.dictName" v-for="item in baseRoleCodeData"
								v-bind:key="item.dictValue"></Checkbox>
						</CheckboxGroup>
					</FormItem>

					<FormItem label="功能描述：" prop="locationDesc">
						<Input v-model="modalformValidata.locationDesc" type="textarea" :rows="2"
							@on-keyup="intCheck(modalformValidata.locationDesc)" />
					</FormItem>
				</Form>
			</Modal>
		</div>
		<div>
			<Modal v-model="modal2" title="路径新增编辑" width="30%" @on-ok="locationEditfunc()">
				<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
					<FormItem label="所属分组：" prop="locationGroup">
						<Input v-model="modalformValidata.locationGroup" />
					</FormItem>
					<FormItem label="访问路径：" prop="locationUrl">
						<Input v-model="modalformValidata.locationUrl" />
					</FormItem>
					<FormItem label="连接版本：" prop="apiVersion">
						<Input v-model="modalformValidata.apiVersion" />
					</FormItem>
					<FormItem label="请求类型：" prop="httpMethod">
						<RadioGroup v-model="modalformValidata.httpMethod">
							<Radio label="GET">
								<span>GET</span>
							</Radio>
							<Radio label="POST">
								<span>POST</span>
							</Radio>
							<Radio label="PUT">
								<span>PUT</span>
							</Radio>
							<Radio label="PATCH">
								<span>PATCH</span>
							</Radio>
							<Radio label="DELETE">
								<span>DELETE</span>
							</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="访问角色code：" prop="roleCodes">
						<!-- <CheckboxGroup v-model="baseRoleCodeData" @on-change="change">
							<Checkbox :label="item.dictValue+':'+item.dictName" v-for="item in data4"
								v-bind:key="item.dictValue"></Checkbox>
						</CheckboxGroup> -->

						<CheckboxGroup v-model="modalformValidata.roleCodes" @on-change="change">
							<Checkbox :label="item.dictValue+':'+item.dictName" v-for="item in baseRoleCodeData"
								v-bind:key="item.dictValue"></Checkbox>
						</CheckboxGroup>

					</FormItem>

					<FormItem label="功能描述：" prop="locationDesc">
						<Input v-model="modalformValidata.locationDesc" type="textarea" :rows="2" />
					</FormItem>
				</Form>
			</Modal>
		</div>
	</div>


</template>
<script>
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
		isHistory: 'N',
		locationGroup: null,
		locationUrl:null,
		locationId:null,
	};
	import {
		getDictList,
		getLocationList,
		getLocationSingle,
		locationAdd,
		locationEdit,
		locationDel,
		queryRoleCodesByLocation,
	} from '@/network/index.js';
	export default {
		data() {
			return {
				columns1: [{
						title: '所属分组',
						key: 'locationGroup'
					},
					{
						title: '路径id',
						key: 'locationId'
					},
					{
						title: '访问路径',
						key: 'locationUrl'
					},
					{
						title: '请求类型',
						key: 'httpMethod'
					},
					{
						title: '连接版本',
						key: 'apiVersion'
					},

					{
						title: '功能描述',
						key: 'locationDesc'
					},
					{
						title: '操作',
						slot: 'action',
						width: 140,
						align: 'center',
						fixed: 'right',
					}
				],
				ruleValidate: {
					locationGroup: [{
						required: true,
						message: '所属分组必须填写',
						trigger: 'blur'
					}],
					locationUrl: [{
						required: true,
						message: '访问路径必须填写',
						trigger: 'blur'
					}],
					httpMethod: [{
						required: true,
						message: '请求类型必须填写',
						trigger: 'blur'
					}],
					apiVersion: [{
						required: true,
						message: '连接版本必须填写',
						trigger: 'blur'
					}],
					roleCodes: [{
						required: true,
						message: '访问角色code必须填写',
						trigger: 'blur'
					}],
				},
				modalformValidata: {
					locationId: '',
					locationGroup: '',
					locationUrl: '',
					httpMethod: 'GET',
					apiVersion: 'v1',
					locationDesc: '',
					roleCodes: ['ROLE_ADMIN:系统管理员'],
				},
				data1: [],
				data4: [],
				baseRoleCodeData: [], //选中的角色code
				roleCodes: '',
				tempRoleCodes: [],
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,

				locationId: 0,
				modal1: false,
				modal2: false,


				locationDataTpye: {
					locationCode: '',
				},
				pointChangerType: [],



			}
		},
		created() {
			this.initData(paramter);


		},
		methods: {


			//删除方法
			locationDelMain(row) {
				locationDel(row.locationId, null).then(res => {
						if (res.success == true) {
							this.$Message.success('用户路径成功!');

							this.initData(paramter);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						console.log(error)
					});
			},

			//修改主方法
			locationEditMain(row) {
				this.modal2 = true;
				this.locationId = row.locationId;

				//获取角色权限
				let paramterTemp = {
					dictCode: 'base_role_code',
				};
				getDictList(paramterTemp).then(res => {

						this.baseRoleCodeData = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.baseRoleCodeData.push({
								dictValue: res.data.obj.dataList[i].dictValue,
								dictName: res.data.obj.dataList[i].dictName
							});
						}
					})
					.catch(error => {});

				//查看已有的角色
 
               
				  let paramterTemp1 = {
				  	locationId: this.locationId
				  };
				queryRoleCodesByLocation(paramterTemp1).then(res => {
						//数据清空
						this.modalformValidata.roleCodes =[];
						for (var i = 0; i < res.data.obj.dataList.length; i++) { 
							this.modalformValidata.roleCodes.push(res.data.obj.dataList[i].roleCode + ':' + res.data.obj.dataList[i].roleCodeName);
						}
						// this.modalformValidata.roleCodes =[];
						// this.modalformValidata.roleCodes = '[' + this.tempRoleCodes + ']';
					})
					.catch(error => {
						console.log(error)
					});


				this.modalformValidata.locationGroup = row.locationGroup;
				this.modalformValidata.locationUrl = row.locationUrl;
				this.modalformValidata.httpMethod = row.httpMethod;
				this.modalformValidata.apiVersion = row.apiVersion;
				this.modalformValidata.locationDesc = row.locationDesc;
			},
			//修改方法
			locationEditfunc() {
				if(this.roleCodes ===''){
					this.roleCodes =  'ROLE_ADMIN' ;
				}
				let paramter = {

					locationGroup: this.modalformValidata.locationGroup,
					locationUrl: this.modalformValidata.locationUrl,
					httpMethod: this.modalformValidata.httpMethod,
					apiVersion: this.modalformValidata.apiVersion,
					locationDesc: this.modalformValidata.locationDesc,
					roleCodes: this.roleCodes,
				};
				locationEdit(this.locationId, paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('码表修改成功!');
							this.modal1 = false;
							//添加后刷新数据
							let paramtertemp = {
								locationCode: this.modalformValidata.locationCode,
							};
							this.initData(paramtertemp);

						} else {
							this.modal2 = false;
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('码表修改失败，请联系管理员!');
						//添加失败关闭对话框
						this.modal2 = false;

					});

			},

			//新增主方法  
			locationAddMain(row) {
				this.modal1 = true;
				//获取角色权限
				let paramterTemp = {
					dictCode: 'base_role_code',
				};
				getDictList(paramterTemp).then(res => {

						this.baseRoleCodeData = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.baseRoleCodeData.push({
								dictValue: res.data.obj.dataList[i].dictValue,
								dictName: res.data.obj.dataList[i].dictName
							});
						}
					})
					.catch(error => {});

			},
			//新增方法 
			locationAddfunc() {
				if(this.roleCodes ===''){
					this.roleCodes =  'ROLE_ADMIN' ;
				}
				let paramter = {
					locationGroup: this.modalformValidata.locationGroup,
					locationUrl: this.modalformValidata.locationUrl,
					httpMethod: this.modalformValidata.httpMethod,
					apiVersion: this.modalformValidata.apiVersion,
					roleCodes: this.roleCodes,
				};
				//debugger;
				locationAdd(paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('路径添加成功!');
							this.modal1 = false;
							//添加后刷新数据
							let paramtertemp = {
								locationCode: this.modalformValidata.locationCode,
							};
							this.initData(paramtertemp);

						} else {
							// 官方目前没有解决方案
							this.modal1 = false;
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('路径添加失败，请联系管理员!');
						//添加失败关闭对话框
						this.modal1 = false;

					});

			},




			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData()
			},
			initData(paramter) {
				getLocationList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								locationId: res.data.obj.dataList[i].locationId,
								locationGroup: res.data.obj.dataList[i].locationGroup,
								locationUrl: res.data.obj.dataList[i].locationUrl,
								httpMethod: res.data.obj.dataList[i].httpMethod,
								apiVersion: res.data.obj.dataList[i].apiVersion,
								locationDesc: res.data.obj.dataList[i].locationDesc,
							});
						}


					})
					.catch(error => {});


			},





			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
				paramter.locationGroup = null;
				paramter.locationUrl = null;
			},
			//查询提交
			handleSubmit() {

				if (this.modalformValidata.locationGroup != null && this.modalformValidata.locationGroup != '') {
					paramter.locationGroup = this.modalformValidata.locationGroup;
				}
				if (this.modalformValidata.locationUrl != null && this.modalformValidata.locationUrl != '') {
					paramter.locationUrl = this.modalformValidata.locationUrl;
				}
				if (this.modalformValidata.locationId != null && this.modalformValidata.locationId != '') {
					paramter.locationId = this.modalformValidata.locationId;
				}



				getLocationList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								locationId: res.data.obj.dataList[i].locationId,
								locationGroup: res.data.obj.dataList[i].locationGroup,
								locationUrl: res.data.obj.dataList[i].locationUrl,
								httpMethod: res.data.obj.dataList[i].httpMethod,
								apiVersion: res.data.obj.dataList[i].apiVersion,
								locationDesc: res.data.obj.dataList[i].locationDesc,
							});
						}
					})
					.catch(error => {});
			},

			change(data) { //事件写在Checkbox-group里返回的是选中的数组，写在Checkbox返回的是boolean值
				this.roleCodes = '';
				let temp = JSON.stringify(data);
				let arry = temp.split(',');
				for (var i = 0; i < arry.length; i++) {
					if ('' == this.roleCodes) {
						this.roleCodes = arry[i].split(":")[0].replaceAll('["', '');
					} else {
						this.roleCodes = this.roleCodes + ',' + arry[i].split(":")[0].replaceAll('["', '');
					}
				}
				this.roleCodes = this.roleCodes.replaceAll('"', '');
			},
		},


	}
</script>

<style lang="scss" scoped>
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}


	#divcss5 {
		display: flex; //水平分布
		border: 1px dashed #ff0000;
		height: 30px;
		width: 100%;


	}

	.item {
		flex: 1; //等分
		text-align: center; //等分后居中
		font-size: 18px;
	}


	#head-logo {
		width: 200px;
		height: 200px;
		text-align: center;
		border-radius: 3px; //添加圆角
	}
</style>
